export default __webpack_public_path__ + "static/media/320x320.b3f33f33.jpg";